import { useMutation } from '@tanstack/react-query';
import { getApiClient } from '@signalvote/api-client';
import { defineQuery, requireSelectedCampaign } from '@/lib/data';

const api = getApiClient();

/**
 * Visible categories (defaults + non-hidden custom with access). Category writes answer with
 * TaskCategory or TaskCategoryAccess, which this read declares, so the mutations below list no keys.
 */
export const useTaskCategories = defineQuery({
  key: () => ['taskCategories', 'visible'],
  reads: 'GET /api/task-categories',
  fetch: (_: undefined, { campaignId }) => {
    requireSelectedCampaign(campaignId);
    return api.taskCategories.getCategories();
  },
});

/** Create a custom category */
export function useCreateCategory() {

  return useMutation({
    mutationFn: (name: string) => api.taskCategories.createCategory({ name }),
  });
}

/** Hide a custom category */
export function useHideCategory() {

  return useMutation({
    mutationFn: (id: string) => api.taskCategories.hideCategory(id),
  });
}

/** Rename a custom category */
export function useRenameCategory() {

  return useMutation({
    mutationFn: ({ id, name }: { id: string; name: string }) =>
      api.taskCategories.renameCategory(id, { name }),
  });
}

/** Delete a custom category */
export function useDeleteCategory() {

  return useMutation({
    mutationFn: (id: string) => api.taskCategories.deleteCategory(id),
  });
}
